// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "offer".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { offerDiscountTypeValues, offerStateValues } from '@borradh-workspace/labels';
/** Response atom for the "offer" table (1:1 with a DB row, on the wire). */
export const offerAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    code: z.string().nullable(),
    state: z.enum(offerStateValues),
    bookableOnline: z.boolean(),
    validFrom: z.string().datetime().nullable(),
    validUntil: z.string().datetime().nullable(),
    discountType: z.enum(offerDiscountTypeValues),
    discountPercent: z.number().nullable(),
    discountAmountCents: z.number().nullable(),
    unreadLegacyOriginalPriceCents: z.number().nullable(),
    offerPriceCents: z.number().nullable(),
    buyQuantity: z.number().nullable(),
    getQuantity: z.number().nullable(),
    limitPerClient: z.boolean(),
    redemptionLimit: z.number().nullable(),
    redemptionCount: z.number(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    deletedAt: z.string().datetime().nullable(),
});
//# sourceMappingURL=offer.js.map